import { render, staticRenderFns } from "./LinkedAccountDefaults.vue?vue&type=template&id=d23b7e98&scoped=true"
import script from "./LinkedAccountDefaults.vue?vue&type=script&lang=ts"
export * from "./LinkedAccountDefaults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23b7e98",
  null
  
)

export default component.exports